var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    String.prototype.endsWith = function (suffix) {
        var index = this.lastIndexOf(suffix);
        return index >= 0 && index + suffix.length === this.length;
    };
    String.prototype.startsWith = function (prefix) {
        return this.indexOf(prefix) === 0;
    };
    var templatePattern = /\{\{([^\}]+)\}\}/g;
    function template(text, data) {
        return text.replace(templatePattern, function (_, key) { return data[key] || key; });
    }
    exports.template = template;
    function delay(interval, val) {
        var r = $.Deferred();
        setTimeout(function () {
            r.resolve(val);
        }, interval);
        return r;
    }
    exports.delay = delay;
    exports.mobileOsProbes = {
        ios: /(iPhone|iPad|iPod)/,
        android: /Android/
    };
    exports.detectMobileOS = function () {
        var agent = navigator.userAgent;
        return Object.keys(exports.mobileOsProbes).reduce(function (x, k) { return x || (exports.mobileOsProbes[k].exec(agent) ? k : undefined); }, undefined);
    };
    exports.uncurry = function (fn) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.reduce(function (cur, arg) { return cur(arg); }, fn);
    }; };
    exports.allMatches = function (text) { return function (regex) {
        var result = [];
        var cur = text;
        var match = cur.match(regex);
        while (match) {
            result.push(match);
            cur = cur.substr(match.index + match[0].length);
        }
        return result;
    }; };
    exports.omitUndefined = function (obj) { return (Object.keys(obj).reduce(function (cur, k) {
        var _a;
        return obj[k] === undefined ? cur : __assign({}, cur, (_a = {}, _a[k] = obj[k], _a));
    }, {})); };
    exports.transformVal = function (tx) { return function (obj) { return Object.keys(obj).reduce(function (cur, k) {
        var _a;
        return (__assign({}, cur, (_a = {}, _a[k] = tx(obj[k]), _a)));
    }, {}); }; };
    exports.arityExtend = function (op) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var head = args[0], rest = args.slice(1);
        return rest.reduce(function (cur, x) { return op(cur, x); }, head);
    }; };
    exports.select = function (sel) { return function () {
        var objs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objs[_i] = arguments[_i];
        }
        return Object.keys(objs[0]).reduce(function (cur, k) {
            var _a;
            return (__assign({}, cur, (_a = {}, _a[k] = sel.apply(null, objs.map(function (x) { return x[k]; })), _a)));
        }, {});
    }; };
    exports.minVector = exports.select(exports.arityExtend(Math.min));
    exports.findFirst = function (array, predicate) {
        for (var i in array) {
            if (predicate(array[i])) {
                return array[i];
            }
        }
        return undefined;
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/util.js
// module id = 13
// module chunks = 0